import React from "react";
import { Box, Typography } from "@mui/material";
function PageError() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 500 }}>
        404 Error | Page Not Found
      </Typography>
    </Box>
  );
}

export default PageError;
